import { render, staticRenderFns } from "./TypeDetailPage.vue?vue&type=template&id=44e94b12&scoped=true"
import script from "./TypeDetailPage.vue?vue&type=script&lang=js"
export * from "./TypeDetailPage.vue?vue&type=script&lang=js"
import style0 from "./TypeDetailPage.vue?vue&type=style&index=0&id=44e94b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e94b12",
  null
  
)

export default component.exports